﻿import { CommonFlags as c, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../../Cadenas/Cadenas";
import { catCanales } from "../../Categorias y Estados/catCanales";
import { estActivo } from "../../Categorias y Estados/estActivo";
import { Ciudades } from "../../Paises/Ciudades/Ciudades";
import { Localidades } from "../../Paises/Localidades/Localidades";
import { Paises } from "../../Paises/Paises";
import { Provincias } from "../../Paises/Provincias/Provincias";

const columns = () =>
(
    {
        c_pais_id: new EntityColumn<string>({ name: 'c_pais_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'País' }),
        c_provincia_id: new EntityColumn<string>({ name: 'c_provincia_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Provincia' }),
        c_ciudad_id: new EntityColumn<string>({ name: 'c_ciudad_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Ciudad' }),
        c_localidad_id: new EntityColumn<string>({ name: 'c_localidad_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Localidad' }),
        vc_cadenas: new EntityColumn<string[]>({ name: 'vc_cadenas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Cadenas', isArray: true }),
        vc_canales: new EntityColumn<string[]>({ name: 'vc_canales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Canales', isArray: true }),
        c_activo_id: new EntityColumn<string>({ name: 'c_activo_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado' }),
    }
)
const lookups = () =>
(
    {
        'Activo': {
            name: 'Activo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estActivo(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catCanales(client, parentKeys)
        },
        'Paises': {
            name: 'Paises',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Paises(client, parentKeys)
        },

        'Provincias': {
            name: 'Provincias',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Provincias(client, parentKeys)
        },

        'Ciudades': {
            name: 'Ciudades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Ciudades(client, parentKeys)
        },

        'Localidades': {
            name: 'Localidades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Localidades(client, parentKeys)
        },
    }
)

export class TiendasFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('TiendasFilters');
    }
}